import { IntlObject } from 'i18n/types';

export interface PriceFilterValue {
  currency: string | null;
  min: number | null;
  max: number | null;
}

export interface PriceFilterChange {
  min: number;
  max: number;
  currency: string;
}

export interface PriceFilterProps {
  currency: string;
  currencyRates: { [key: string]: number };
  trimmedPriceDistribution: Array<{ range: number; value: number }>;
  trimmedPriceMax: number;
  trimmedPriceMin: number;
  priceMax: number;
  priceMin: number;
  selectedMin: number;
  selectedMax: number;
}

export const enum TypeValue {
  PRIVATE_ROOM = 'private-rooms',
  SHARED_ROOM = 'shared-rooms',
  APARTMENT = 'apartment-for-rent',
  STUDIO = 'studio-for-rent',
}
export type TypeFilterValue = TypeValue[];
export type DateString = string | null;

export interface DateFilterValue {
  startDate: DateString;
  endDate: DateString;
}

export type FurnitureValue = 'furnished' | 'unfurnished';
export type FurnitureFilterValue = FurnitureValue | null;

export type BillsValue = 'included' | 'excluded';
export type BillsFilterValue = BillsValue | null;

export enum GenderValue {
  GIRLS = 'female',
  BOYS = 'male',
}

export type GenderFilterValue = GenderValue[];

export type RegistrationValue = 'possible' | 'not-possible';
export type RegistrationFilterValue = RegistrationValue | null;

export enum Options {
  NO = 'no',
  YES = 'yes',
  DISCUSSABLE = 'discussable',
  OUTSIDE = 'outside_only',
}

export enum RulesValue {
  SMOKING = 'smoking_allowed',
  PETS = 'pets_allowed',
  INSTRUMENT = 'playing_instrument_allowed',
}

export type RulesFilterValue = RulesValue[];

export type RoomsFilterProperty = 'bedroomCount';
export interface RoomsFilterValue {
  bedroomCount: number;
}

export type RecentlyAddedValue = '1-day' | '3-days' | '7-days' | '14-days';
export type RecentlyAddedFilterValue = RecentlyAddedValue | null;

export enum SuitableForValue {
  Students = 'students',
  WorkingProfessionals = 'working-professionals',
  Couples = 'couples',
}

export type SuitableForFilterValue = SuitableForValue[];

export type CanonicalCollection =
  | TypeValue
  | 'cheap-accommodation'
  | 'furnished-apartments'
  | '';

export type FilterSubmit = (filters: {
  dates?: DateFilterValue;
  types?: TypeFilterValue;
  furniture?: FurnitureFilterValue;
  bills?: BillsFilterValue;
  rooms?: RoomsFilterValue;
  rules?: RulesFilterValue;
  price?: PriceFilterValue;
  registration?: RegistrationFilterValue;
  recentlyAdded?: RecentlyAddedFilterValue;
  gender?: GenderFilterValue;
  suitableFor?: SuitableForFilterValue;
  intl?: IntlObject;
}) => void;
